import { Link } from '~/components/Link'

import { IconName } from './Icons'
import ExcelIcon from './Icons/svgs/ExcelIcon'
import GeogebraIcon from './Icons/svgs/GeogebraIcon'
import SVGIcon from './Icons/svgs/SVGIcon'
interface IconIsImage {
  image: string
  icon?: undefined
}

interface IconIsHomIcon {
  image?: undefined
  icon: IconName
}

interface FramedButtonItemProps {
  disabledText?: string
  name: string
  path: string
}

const getIconComponent = (name: string): ((props: { [key: string]: any }) => React.ReactElement) => {
  switch (name) {
    case 'excel':
      return ExcelIcon
    case 'geogebra':
      return GeogebraIcon

    default:
      return GeogebraIcon
  }
}

export function FramedButtonItem({
  disabledText = '',
  icon,
  image,
  name,
  path,
}: FramedButtonItemProps & (IconIsImage | IconIsHomIcon)): React.ReactElement {
  return (
    <section
      className={
        'w-full self-start rounded gradient-border-container ' +
        `${disabledText ? 'pointer-events-none opacity-75' : ''}`
      }
    >
      <Link
        className={
          'p-2 2xl:p-5 h-40 flex flex-col items-center justify-evenly rounded shadow-experimental ' +
          'text-center cursor-pointer bg-white hover:bg-blue-light'
        }
        key={name}
        to={path}
      >
        <div className="text-purple text-md font-semibold">{name}</div>
        {icon && <SVGIcon icon={getIconComponent(icon)} size={80} />}
        {image && <img alt={name} className="max-h-20" src={image} />}

        <small className="text-2.5 text-gray-light-fade">{disabledText}</small>
      </Link>
    </section>
  )
}
